import { AxiosRequestConfig } from 'axios';
import { httpClient, ApiResponse, convertModelToFormData } from '@/utils';
import {
  ProductsEndpoints,
  ExportEndpoints,
  IImportProductsDTO,
  IProductsImportTemplateDTO,
  IProductsImportTemplateResponse,
  IGetImportsListDTO,
  IImportsListResponse,
  IImportStocksDTO,
  IStocksImportTemplateDTO,
  IStocksImportTemplateResponse,
  IExportStatusResponse,
} from '@/models/productsImport.model';

class ProductsImportAPI {
  static getProductsImportTemplate(data: IProductsImportTemplateDTO): ApiResponse<IProductsImportTemplateResponse> {
    return httpClient.get<IProductsImportTemplateResponse>(ProductsEndpoints.PRODUCTS_IMPORT_TEMPLATE, {
      params: data,
    });
  }
  static getImportsList(data: IGetImportsListDTO): ApiResponse<IImportsListResponse> {
    return httpClient.get<IImportsListResponse>(ProductsEndpoints.PRODUCTS_IMPORT, {
      params: data,
    });
  }
  static importProducts(data: IImportProductsDTO): ApiResponse<void> {
    return httpClient.post<void>(ProductsEndpoints.PRODUCTS_IMPORT, convertModelToFormData(data));
  }

  static getStocksImportTemplate(data: IStocksImportTemplateDTO): ApiResponse<IStocksImportTemplateResponse> {
    return httpClient.get<IStocksImportTemplateResponse>(ProductsEndpoints.STOCKS_IMPORT_TEMPLATE, {
      params: data,
    });
  }

  static importStocks(data: IImportStocksDTO): ApiResponse<void> {
    return httpClient.post<void>(ProductsEndpoints.STOCKS_IMPORT, convertModelToFormData(data));
  }

  static getExportStatus(id: string, config?: AxiosRequestConfig): ApiResponse<IExportStatusResponse> {
    return httpClient.get<IExportStatusResponse>(`${ExportEndpoints.EXPORT_STATUS}/${id}`, config);
  }
}

export default ProductsImportAPI;
